<template>
  <div>
    <card v-loading="loading" :title="$t('cardPage.title')">
      <span v-if="error">{{ JSON.stringify(error) }}</span>
      <span v-else-if="details">
      <card-details-view :details="details"/>
    </span>
    </card>
  </div>
</template>
<script>
import CardDetailsView from './CardDetailsView'
import {mapActions, mapState} from "vuex";

export default {
  name: 'cardPage',
  components: {
    CardDetailsView
  },
  methods: {
    ...mapActions(['LoadCard']),
  },
  computed: {
    ...mapState({
      loading: state => state.card.loading,
      details: state => state.card.data,
      error: state => state.card.error,
    }),
  },
  mounted() {
    this.LoadCard({id: this.$route.params.id})
  }
};
</script>
<style>
</style>
